import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class ApiService {
    //private baseUrl = `https://69xf32siej.execute-api.us-east-1.amazonaws.com/prod`;
    private baseUrl = `http://localhost:5000`;

    constructor(private http: HttpClient) {}

    importNotes(v2Token: string, tableId: string, clippings: string) {
        return this.http.post(
            this.baseUrl + '/export',
            {
                "v2Token": v2Token,
                "tableId": tableId,
                "clippings": clippings
            },
            {
                headers: new HttpHeaders(
                    {
                        "Content-Type": "application/json"
                    }
                )
            }
        );
    }

    importNotesFree(v2Token: string, tableId: string, clippings: string) {
        return this.http.post(
            this.baseUrl + '/export-free',
            {
                "v2Token": v2Token,
                "tableId": tableId,
                "clippings": clippings
            },
            {
                headers: new HttpHeaders(
                    {
                        "Content-Type": "application/json"
                    }
                )
            }
        );
    }

    createCheckoutSession() {
        return this.http.post(
            this.baseUrl + '/checkout-session',
            {

            },
            {
                headers: new HttpHeaders(
                    {
                        "Content-Type": "application/json"
                    }
                )
            }
        );
    }

    checkSuccessfulPurchase(sessionId: string) {
        return this.http.get(
            this.baseUrl + '/success?session_id=' + sessionId,
            {
                headers: new HttpHeaders(
                    {
                        "Content-Type": "application/json"
                    }
                )
            }
        )
    }
}